// The jobs-list column set and its enum→i18n-key maps.
//
// Legacy inlined all of this in the component: the nine column headers (`DataExportTable.vue:212-222`)
// and the five write-mode titles (`:224-230`) were hardcoded English, and the lookup itself was
// `update_mode_options.find(o => o.value === …).title` (`:104`) — an unguarded `.find(...).title`
// that THREW, blanking the whole table, on any row whose `update_mode` the array did not list.
// `resolveExportLabel` degrades to a humanised id instead.
export const EXPORT_JOB_COLUMNS = [
  { field: 'name', width: 200 },
  { field: 'sources', width: 180 },
  { field: 'destination', width: 190 },
  { field: 'createdAt', width: 150 },
  { field: 'updatedAt', width: 150 },
  { field: 'frequency', width: 120 },
  { field: 'nextRun', width: 150 },
  { field: 'updateMode', width: 170 },
  { field: 'actions', width: 110 },
] as const

/** `DataExportTable.vue:224-230`, keyed. */
export const UPDATE_MODE_LABEL_KEYS: Readonly<Record<string, string>> = {
  append: 'dataExport.updateModes.append',
  replace: 'dataExport.updateModes.replace',
  update: 'dataExport.updateModes.update',
  upsert: 'dataExport.updateModes.upsert',
  make_new: 'dataExport.updateModes.makeNew',
}

/** The eight export platforms (`exportJob.types.ts` `ExportPlatform`). */
export const PLATFORM_LABEL_KEYS: Readonly<Record<string, string>> = {
  meta_ads: 'dataExport.platforms.metaAds',
  google_ads: 'dataExport.platforms.googleAds',
  tiktok_ads: 'dataExport.platforms.tiktokAds',
  google_analytics: 'dataExport.platforms.googleAnalytics',
  appsflyer: 'dataExport.platforms.appsflyer',
  adjust: 'dataExport.platforms.adjust',
  google_search_console: 'dataExport.platforms.googleSearchConsole',
  criteo: 'dataExport.platforms.criteo',
}

export const FREQUENCY_LABEL_KEYS: Readonly<Record<string, string>> = {
  once: 'dataExport.schedule.frequencies.once',
  daily: 'dataExport.schedule.frequencies.daily',
  weekly: 'dataExport.schedule.frequencies.weekly',
  monthly: 'dataExport.schedule.frequencies.monthly',
}

/** Matches `useFormat`'s own empty-value sentinel so blank cells read the same everywhere. */
export const EXPORT_DASH = '-'

/**
 * Legacy's `capitalizeKeyword` (`:292-300`). Kept ONLY as the unmapped-id fallback — legacy also
 * ran it over the user-entered export NAME (`:95`), which rewrote the user's own copy.
 */
export function humanizeExportValue(value: string): string {
  return value
    .split(/[_\s]+/u)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function resolveExportLabel(
  keys: Readonly<Record<string, string>>,
  value: string,
  translate: (key: string) => string,
): string {
  if (!value) return EXPORT_DASH
  const key = keys[value]
  return key === undefined ? humanizeExportValue(value) : translate(key)
}
